import { Box, Table, Text } from '@factorialco/deprecated-design-system'

import { columns } from 'modules/finance/components/TaxType/columns'
import type { TaxRateFragment } from 'modules/finance/hooks/useTaxTypes'

import TaxRatePopover from './TaxRatePopover'

interface Props {
  taxRate: TaxRateFragment
  onDelete: () => void
}

const TaxValueRow = ({ taxRate, onDelete }: Props) => {
  const formatPercentage = (amount: number) => {
    const percentage = amount * 100
    return parseFloat(percentage.toFixed(2)).toString()
  }

  return (
    <Table.Row key={taxRate.id}>
      <Table.Cell colSpan={columns.amount.colSpan}>
        <Text.Normal>{formatPercentage(taxRate.rate)}%</Text.Normal>
      </Table.Cell>
      <Table.Cell colSpan={columns.description.colSpan}>
        <Box justifyContent="spaceBetween" flexDirection="row" minHeight="s32">
          <Text.Normal ellipsis>{taxRate.description}</Text.Normal>
          {taxRate.source === 'custom' && <TaxRatePopover onDelete={onDelete} />}
        </Box>
      </Table.Cell>
    </Table.Row>
  )
}

export default TaxValueRow
